import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

export const BannerWrapper = styled.div`
  background-color: ${getToken('color-success-light')};
  padding: ${getToken('space-m')};
  display: flex;
  align-items: flex-start;
  gap: ${getToken('space-s')};
`

export const LogoWrapper = styled.div`
  background-color: ${getToken('color-neutral-white')};
  padding: ${getToken('space-s')};
  border-radius: 4px;

  svg {
    path {
      fill: ${getToken('color-primary')};
    }
  }
`
